export const useTelegram = () => {
    return window.Telegram?.WebApp
}